var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderClosed20(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud/20/Folder",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.581.5h2.212c.32 0 .627.127.853.354.414.413.976.646 1.561.646h5.909c.861 0 1.18.072 1.497.241.278.15.497.368.646.646.169.317.241.636.241 1.497h0v7.232c0 .861-.072 1.18-.241 1.497a1.551 1.551 0 01-.646.646c-.317.169-.636.241-1.497.241h0H2.884c-.861 0-1.18-.072-1.497-.241a1.551 1.551 0 01-.646-.646C.572 12.296.5 11.977.5 11.116h0V2.58c0-.532.078-.888.241-1.194.15-.278.368-.497.646-.646C1.693.578 2.049.5 2.58.5h0z",
    id: "Rectangle",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillOpacity: 0.2,
    fill: "currentColor",
    d: "M1 4h14v9H1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fill: "currentColor",
    d: "M1 3h14v1H1z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderClosed20);
export default __webpack_public_path__ + "static/media/folder-closed-20.13efcafb.svg";
export { ForwardRef as ReactComponent };